<article
  appAnimateOnScroll
  class="card text-center shadow-sm border-0 h-100 weather-card"
>
  <div class="card-body">
    <i
      [class]="'fa-solid ' + icon + ' fa-2x ' + iconColor + ' mb-2'"
      aria-hidden="true"
    ></i>
    <h3 class="fw-bold fs-2 mb-1">{{ value }}</h3>
    <p class="mb-0 text-muted">{{ label }}</p>
  </div>
</article>
